<form [formGroup]="group">
    <!-- <div formArrayName="filters">

    </div> -->
      <!-- filters  -->
      <div class="sub-actions-accordion">
        <mat-accordion togglePosition="before" displayMode="flat">
        <mat-expansion-panel togglePosition="before" displayMode="flat" >
          <mat-expansion-panel-header>
            <mat-panel-title>Filters</mat-panel-title>
          </mat-expansion-panel-header>
          <div formArrayName="filters">
          <ng-container *ngFor="let filter of filters.controls; let filterIndex = index">
              <!-- widget type filter -->
              <mat-accordion togglePosition="before" displayMode="flat">
                <mat-expansion-panel togglePosition="before" displayMode="flat" class="mb-2">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <p class="label">{{filter.value.filterType | titlecase}}</p>
                      <p class="value">
                        @if(filter.value.filterType === dropdownDataSourceFilterTypes.manual){
                          {{( filter.value.ref ?? '') | titlecase}}
                        }
                      </p>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
              <div [formGroupName]="filterIndex">
            @if(filter.value.filterType === dropdownDataSourceFilterTypes.widget){
             
              <ng-container [ngTemplateOutlet]="filterTypeWidget" [ngTemplateOutletContext]="{ group: filter }"></ng-container>
            
          }@else if(filter.value.filterType === dropdownDataSourceFilterTypes.manual){
            <ng-container [ngTemplateOutlet]="filterTypeManual" [ngTemplateOutletContext]="{ group: filter }"></ng-container>
          }
        </div>
        <div class="float-end validations-button">
          @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
          <button mat-flat-button color="warn"
          (click)="removeDataSourceFilter(filterIndex,filter.value)">Remove</button>
          }
          </div>
        </mat-expansion-panel>
        </mat-accordion>
        </ng-container>
        </div>
        @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
          <button mat-stroked-button color="primary" class="w-100 mt-2" [matMenuTriggerFor]="filterTypes"  ><mat-icon>add</mat-icon> Add</button>
        }
        <mat-menu #filterTypes="matMenu">
          <button mat-menu-item *ngFor="let item of dropdownDataSourceFiltersMenu;let i = index" (click)="addDataSourceFilter(item,i)">
            {{ item | titlecase}}
          </button>
        </mat-menu>

        <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                <mat-label>Select operator</mat-label>
                <mat-select formControlName="operator">
                  <mat-option *ngFor="let operator of ['and','or']" [value]="operator" >{{operator| titlecase}}</mat-option>
                </mat-select>
              </mat-form-field>
        </mat-expansion-panel>
      </mat-accordion>
      </div>
</form> 
 
 
 
 <!-- dropdown dataSource FilterGroups  -->
 <ng-template #filterTypeWidget let-group="group">
    <div [formGroup]="group">
      <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
        <mat-label>Filter type</mat-label>
        <mat-select formControlName="filterType"   searchable [isObjectsList]="true" [displayKey]="'entity_name'">
          <mat-option *ngFor="let type of [dropdownDataSourceFilterTypes.manual,dropdownDataSourceFilterTypes.widget]" [value]="type" >{{type | titlecase}}</mat-option>
        </mat-select>
      </mat-form-field>
          <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
            <mat-label>Select entity</mat-label>
            <mat-select formControlName="basedEntitys" multiple   searchable [isObjectsList]="true" [displayKey]="'entity_name'" (selectionChange)="fetchAndPatchBasedWntityWidget($event,group)">
              <mat-option *ngFor="let entity of entities" [value]="entity.entity_id" >{{entity.entity_name}}</mat-option>
            </mat-select>
          </mat-form-field>
      <div formArrayName="basedWidgetIds">
        <ng-container *ngFor="let entitywidgetMapping of $any(group.get('basedWidgetIds')).controls; let entityIndex = index">
          <mat-accordion togglePosition="before" displayMode="flat">
            <mat-expansion-panel class="sub-panel mb-2" togglePosition="before" displayMode="flat">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ getSelectedEntityName(entitywidgetMapping)}}</mat-panel-title>
          </mat-expansion-panel-header>
          <div [formGroupName]="entityIndex" class="gap-2 align-items-center">
            <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
              <mat-label>Widgets</mat-label>
              <mat-select formControlName="basedWidgets" placeholder="select widgets" multiple  searchable [isObjectsList]="true" [displayKey]="'widgetLabel'" (selectionChange)="addItemsInbasedWidgetControlMappingArray($event,entityIndex,entitywidgetMapping)">
                <mat-option *ngFor="let widget of getEntityRelatedWidgets(entitywidgetMapping,entityIndex)" [value]="widget.widgetId" >{{widget.widgetLabel}}</mat-option>
              </mat-select>
            </mat-form-field>

            <div formArrayName="basedWidgetControlMapping">
              <ng-container *ngFor="let entitywidget of $any(entitywidgetMapping.get('basedWidgetControlMapping')).controls; let j = index">
                <div [formGroupName]="j" class="gap-2 align-items-center">
                <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                  <mat-label>{{ entitiesWidgetsMappingObj[entitywidgetMapping.value.entityId][entitywidget.value.widgetId]?.widgetLabel ?? 'widget'}}</mat-label>
                  <mat-select formControlName="dependentValue"   searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
                    <mat-option *ngFor="let widget of listOfWidgetsOfEntity" [value]="widget.widgetId" >{{widget.widgetLabel}}</mat-option>
                  </mat-select>
                </mat-form-field>
                </div>
              </ng-container>
          </div>
            </div>
        </mat-expansion-panel>
        </mat-accordion>
          </ng-container>
      </div>
    </div>
  </ng-template>
  <ng-template #filterTypeManual let-group="group">
    <div [formGroup]="group">
      <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
        <mat-label>Filter type</mat-label>
        <mat-select formControlName="filterType"   searchable [isObjectsList]="true" [displayKey]="'entity_name'">
          <mat-option *ngFor="let type of [dropdownDataSourceFilterTypes.manual]" [value]="type" >{{type | titlecase}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
        <mat-label>Filter string</mat-label>
        <input type="text" matInput formControlName="ref">
      </mat-form-field>
      <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
        <mat-label>Depentend Field</mat-label>
        <mat-select formControlName="dependentValue"   searchable [isObjectsList]="true" [displayKey]="'widgetLabel'">
          <mat-option *ngFor="let widget of listOfWidgetsOfEntity" [value]="widget.widgetId" >{{widget.widgetLabel}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-template>